import { render, staticRenderFns } from "./foundational_icon.vue.js?vue&type=template&id=0e2b8e52&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./foundational_icon.vue?vue&type=template&id=0e2b8e52&vue3"
import script from "./foundational_icon.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./foundational_icon.vue?vue&type=script&lang=js&vue3"
export * from "./foundational_icon.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./foundational_icon.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports